import { render, staticRenderFns } from "./prediction.vue?vue&type=template&id=150ab5ca"
import script from "./prediction.vue?vue&type=script&lang=js"
export * from "./prediction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports